import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(({
    dialogContent: {
        '&.MuiDialog-paper': {
            maxWidth: 'auto'
        }
    },
    container: {
        marginTop: '20px',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr'
    },
    iconButton: {
        position: 'absolute',
        right: '10px',
        top: 0
    },
    title: {
        padding: '12px',
        color: 'white',
        background: '#35465c'
    },
    fileContainer: {
        padding: '12px 0 12px 12px'
    },
    fileTitle: {
        fontWeight: 'bold'
    },
    fileShort: {
        maxWidth: '250px',
        wordWrap: 'break-word',
        overflow: 'wrap'
    },
    stateContainer: {
        display: 'flex',
        padding: '0 12px 20px 12px'
    }
}))